import { api } from '../../AxiosConfig';

export class AgendamentoPagamentosService {
    getSettings() {
        return api.get('/agendamento-pagamentos/settings');
    }

    updateSettings(payload: any) {
        return api.put('/agendamento-pagamentos/settings', payload);
    }

    getRequirement(params: { estabId: string; startAt?: string | Date; localDate?: string; startMinutes?: number; clientId?: string }) {
        return api.get('/agendamento-pagamentos/requirement', { params });
    }
}
